import { createApp } from 'vue';
import { Lazyload, ImagePreview } from 'vant';

// 引入函数组件样式，由于按需引入插件无法自动引入函数组件，故手动引入
// https://vant-contrib.gitee.io/vant/#/zh-CN/quickstart#4.-yin-ru-han-shu-zu-jian-de-yang-shi
// Toast
import 'vant/es/toast/style';
// Dialog
import 'vant/es/dialog/style';
// Notify
import 'vant/es/notify/style';
// ImagePreview
import 'vant/es/image-preview/style';

import './style.css';

import App from './App.vue';

import router from './router';

import store from './store/index';

// 长按自定义事件导入
import LongPress from './directives/longPress';

// 视频播放

// import VideoPlayer from 'vue-video-player';
// import 'video.js/dist/video-js.css';
// import 'vue-video-player/src/custom-theme.css';

// import './style.css';
const app = createApp(App);
// app.use(store).use(router).use(VueWechatTitle).use(Lazyload).mount('#app');
app.use(store).use(router).use(Lazyload).mount('#app');
// 增加长按事件
app.directive('longPress', LongPress);
app.use(ImagePreview);

// app.use(VideoPlayer);
